export { wrapPageElement, wrapRootElement } from './lib/gatsby-browser';
